<div class="px-[64px] py-[50px] lg:w-[506px] bg-white rounded-lg text-center">
  <div class="flex justify-center gap-x-3">
    <fa-icon
      [icon]="faCircleExclamation"
      size="2xl"
      class="text-yellow-300 mt-1" />
    <h2 class="text-[28px] font-bold mb-4">{{ title }}</h2>
  </div>
  <p class="mb-6 whitespace-pre-line text-center">{{ message }}</p>
  <div class="flex justify-end gap-11">
    <ui-button class="w-full" (click)="onCancel()" [outline]="true">{{
      cancelLabel
    }}</ui-button>
    <ui-button class="w-full" (click)="onConfirm()">{{
      confirmLabel
    }}</ui-button>
  </div>
</div>
